import React from "react";
import CustomDialog from "./CustomDialog";
import { Box, Typography } from "@mui/material";
import CustomButton from "./CustomButton";

interface ConfirmDialogProps {
  open: boolean;
  title?: React.ReactNode;
  message?: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonText?: string;
  confirmButtonColor?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Confirm",
  message = "Are you sure?",
  onClose,
  onConfirm,
  confirmButtonText = "Delete",
  confirmButtonColor = "#d32f2f",
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <CustomButton label="Cancel" onClick={onClose} />
          <CustomButton
            label={confirmButtonText}
            onClick={() => {
              onConfirm();
            }}
            variant="contained"
            bgColor={confirmButtonColor}
            textColor="#fff"
          />
        </>
      }
    >
      <Box>
        <Typography>{message}</Typography>
      </Box>
    </CustomDialog>
  );
};

export default ConfirmDialog;
